/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Page from '../templates/Page';
import Intro from '../compositions/About/Intro';
import AboutMe from '../compositions/About/AboutMe';
import Services from '../compositions/About/Services';
import Highlights from '../compositions/About/Highlights';
import Collaboration from '../compositions/About/Collaboration';
import { Testimonials } from '../components';
import { SEO, Section } from '../components';
import { TextAccent } from '../components';

/**
 * About page
 */
const About = () => {
  const data = useStaticQuery(
    graphql`
      query {
        avatar: file(relativePath: { eq: "marko-nikolic-an-face.png" }) {
          childImageSharp {
            fixed(width: 75) {
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
      }
    `
  );

  return (
    <Page preContent={<Intro />}>
      <SEO title="Where can I help | Danijel Grabež" />
      <Section title="About me">
        <AboutMe />
        <Services />
        <Highlights />
        <Collaboration />
        <Testimonials
          authorImage={data.avatar.childImageSharp.fixed}
          authorName="Marko Nikolić"
          authorTitle="Principal Software Architect"
        >
          <TextAccent withSpacing>
            “Danijel is doing such a great job in making products delightful and easy to use. For several years he has
            helped us deliver end-to-end solutions on a high level of quality. He is the person who I know I can go to
            for any development, or design related inquiries.”
          </TextAccent>
        </Testimonials>
      </Section>
    </Page>
  );
};

About.propTypes = {
  path: PropTypes.string.isRequired,
};

export default About;
